import React from 'react';
import { LocalizedStandardDateNoSeconds } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import Table from 'components/core/table/Table';
import TableHead from 'components/core/table/TableHead';
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
// Custom
import { dateGenerator } from 'utils/DateUtils';
import { cpmPaymentErrorShape } from 'constants/PropTypesShapes';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';

const PaymentErrorsList = ({ paymentErrors, timezone }) => {
  const columns = [
    {
      key: 'date',
      labelId: 'field.date',
      field: 'date',
      sortable: false,
      className: 'table-content-3',
    },
    {
      key: 'code',
      labelId: 'field.errorCode',
      field: 'code',
      sortable: false,
      className: 'table-content-3',
    },
    {
      key: 'message',
      labelId: 'field.errorMessage',
      field: 'message',
      sortable: false,
    },
  ];

  return (
    <div className="m-4">
      <Table
        hasElements
        head={(<TableHead columns={columns} />)}
        withFooter={false}
      >
        {paymentErrors.map(({ date, code, message }) => (
          <TableRow key={date.toLowerCase()}>
            <TableCell className="hidden-md-down">
              <LocalizedStandardDateNoSeconds
                value={dateGenerator.dateFromTimezone(date, timezone)}
              />
            </TableCell>
            <TableCell className="hidden-md-down">
              <TruncatedTooltipText>
                {code}
              </TruncatedTooltipText>
            </TableCell>
            <TableCell className="hidden-md-down">
              <TruncatedTooltipText>
                {message}
              </TruncatedTooltipText>
            </TableCell>
          </TableRow>
        ))}
      </Table>
    </div>
  );
};

PaymentErrorsList.propTypes = {
  paymentErrors: PropTypes.arrayOf(cpmPaymentErrorShape).isRequired,
  timezone: PropTypes.string.isRequired,
};

module.exports = PaymentErrorsList;



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/payments/PaymentErrorsList.js